export default "__VITE_ASSET__e1snwjcw__"